import React, { useState } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface OperatorFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function OperatorField({
  options,
  loading,
  disabled = false,
}: OperatorFieldProps) {
  const { t } = useTranslation('create-alarm-step');
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<string[]>([]);

  return (
    <Form.Item
      name="operadoras"
      label={t('create-alarm-step:stepOne.createAlarmOperatorField')}
      rules={[
        {
          required: true,
          message: t('create-alarm-step:stepOne.createAlarmOperatorRequired'),
        },
      ]}
    >
      <Select
        mode="multiple"
        allowClear
        options={options}
        value={value}
        open={open}
        loading={loading}
        disabled={loading || disabled}
        onDropdownVisibleChange={visible => setOpen(visible)}
        onChange={vals => setValue(vals)}
        onSelect={val => {
          setValue([...value, val]);
          setOpen(false);
        }}
      />
    </Form.Item>
  );
}
